/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';


/*Components*/
// import Inputs from '../../components/formComponents/inputs.js';
import DateRange from '../../components/dateRangePicker/dateRange.js';
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input';
import ImageUploader from '../../services/upload/imageUploader';


/*Assets*/
import sampleBanner from '../../assets/images/sample-banner.jpg';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';



class EditModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: [],
      name: "",
      mobile: "",
      email: "",
      seller_type: "",
      website: "",
      category: "",
      category_ids: [],
      sub_category_ids: [],
      product_ids :[],
      categoryOptions: [],
      subCategoryOptions: [],
      productOptions: []
    }
  }
   categoryChange = async (category) =>{
    await this.setState({category: category});
    // this.subCategory([category.value]);
    // console.log("hiiiiii")
  }

   componentDidMount() {


    // this.getData();
    // for (var j = 0; j <= catData.length - 1; j++) {
    //       var item = catData[j]
    //       tempArray.push({value: item.id, label: item.category});
    //     }
    //     this.setState({categoryOptions: tempArray});
    //   }

    var tempArry = []

    this.props.data.category_data.map(function(item, index){
      var tempItem = {value: item.id, label: item.category}
      tempArry.push(tempItem);
    });


    this.setState({
      company: this.props.data.name,
      mobile: this.props.data.mobile,
      email: this.props.data.email,
      seller_type: this.props.data.seller_type,
      website: this.props.data.website,
      category: tempArry
    });

    var url = devconfig.vendor+'category/all-list';
    APIGet(url).then(function(response){
      if(response.status==="ok"){
        var tempArray = [];

        response.data.map(function(item, index){
          var tempItem = {value: item.id, label: item.category}
          tempArry.push(tempItem);
        });
        this.setState({categoryOptions: tempArray});
      }
    }.bind(this))
  }
  editProfile(e){
    e.preventDefault();
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'auth/edit-profile';
    var data = JSON.stringify({
      "logo": this.state.logo,
      "company": this.state.company,
      "name": this.state.name,
      "seller_type_id":1,
      "location":"hi",
      // "address": "sss",
      "document_urls":"www.evoque.com/test/test",
      "category_ids":1,
      // "sub_category_ids": 1,
      // "product_ids": 1,
      // "gst_no": 222,
      
      "mobile": this.state.mobile,
      "email": this.state.email,
      "seller_type":this.state.seller_type,
      "website": this.state.website
    })
    APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        // console.log(response.data);

        this.props.getData();
        $("#editModal").modal('hide');
        // this.setState({ data: response.data,apiLoading: false});
      }
    }.bind(this))
  }
  valueChange(e){
    this.setState({name: e.target.value});
  }
  valueChangePhone(e){
    this.setState({mobile: e.target.value});
  }
  valueChangeEmail(e){
    this.setState({email: e.target.value});
  }
  valueChangeSeller(e){
    this.setState({seller_type: e.target.value});
  }
  valueChangeWebsite(e){
    this.setState({website: e.target.value});
  }

  chooseImage(){
    $("#e-dp-uploader").click();
  }
  async uploadSucess(url, data){
    this.setState({logo:url})
  }
  async uploadStatus(status){
    this.setState({uploading: status})
  }

  render() {
     const categoryBy = [
      { value: 1, label: 'Last 1 week' },
      { value: 2, label: 'Last 1 month' },
      { value: 3, label: 'Last 3 months' },
    ]

    return (
      <div className="modal fade e-ad-detail-wrap e-ofer-modal" id="editModal" tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered"  role="document">
          <div className="modal-content e-ofer">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <h6 className="e-modal-header">Edit Profile</h6>
              </div>
            </div>
             <div className="row mt-3">
                <div className="col-lg-4">
                  <div className="e-subcategory-content ">
                    {
                      this.state.uploading ?
                        <span className="e-upload-btn e-store e-b-list-logo-uploader text-center mb-3"></span>
                      :
                        <React.Fragment>
                          {
                            this.state.logo ?
                              <span className="e-b-list-logo">
                                <span className="e-close-icon" onClick={(e) => this.setState({logo: null})}></span>
                                <img src={this.state.logo}/>
                              </span>
                            :
                              <span className="e-upload-btn e-store text-center mb-3" onClick={this.chooseImage.bind(this)}>Upload your online store logo</span>
                          }
                        </React.Fragment>
                    }
                  
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="e-note-wrap">
                    <p className="e-note pl-3 pt-2">*Note</p>
                    <p className="e-note-content pb-2 pl-3">Logo must be square (400px * 400px)</p>
                  </div>
                </div>
                <div className="col-lg-12 mt-2">
                  <h6>Company Name:</h6>
                  <input id={this.props.id} value={this.state.company} type="text" className="e-profile-edit" onChange={(e) => this.setState({company: e.target.value})}/>
                </div>

                <div className="col-lg-12 mt-2">
                  <h6>Contact Person:</h6>
                  <input id={this.props.id} value={this.state.name} type="text" className="e-profile-edit" onChange={(e) => this.setState({name: e.target.value})}/>
                </div>

                

                {/*<div className="col-lg-12">
                  <h6 className="pt-3">Phone:</h6>
                  <input id={this.props.id} value={this.state.mobile} type="number" className="e-profile-edit" onChange={this.valueChangePhone.bind(this)}/>
                </div>*/}

                {/*<div className="col-lg-12">
                  <h6 className="pt-3">Email:</h6>
                  <input id={this.props.id} value={this.state.email} type="text" className="e-profile-edit" onChange={this.valueChangeEmail.bind(this)}/>
                </div>*/}

                {/*<div className="col-lg-12">
                  <h6 className="pt-3">Seller Type:</h6>
                  <input id={this.props.id} value={this.state.seller_type} type="text" className="e-profile-edit" onChange={this.valueChangeSeller.bind(this)}/>
                </div>*/}

                <div className="col-lg-12">
                  <h6 className="pt-3">Website:</h6>
                  <input id={this.props.id} value={this.state.website} type="text" className="e-profile-edit" onChange={this.valueChangeWebsite.bind(this)}/>
                </div>

                <div className="col-lg-4">
                  <h6 className="pt-3">Category:</h6>
                  <SelectBox defaultValue={this.state.category} selectType={true} options={this.state.categoryOptions} selectchange={this.categoryChange} />
                </div>
              </div>
            <div className="row">
              <div className="col-lg-9">
                <a href="#" className="float-right pt-4 e-ofer-cancel e-offer" data-dismiss="modal">Cancel</a>
              </div>

              <button className="e-s-btn e-new-ofer float-right mt-3 ml-5" type="submit" value="Submit" onClick={this.editProfile.bind(this)}>Create</button>
            </div>

            <div className="modal-footer">


              {/*

              <span className="e-s-link-txt mr-4" data-dismiss="modal">Cancel</span>
              {
                this.state.category && this.state.styleType && this.state.colorOne.length && this.state.colorTwo.length  ?
                  <button type="submit" className="e-s-btn" value="Submit" data-dismiss="modal" onClick={this.submit.bind(this)}>Submit</button>
                :
                  <button type="submit" className="e-s-btn e-inactive" value="Submit" >Submit</button>
              }

            */}

            </div>
          </div>
        </div>

        <ImageUploader
          tempKey="/user/pan-card"
          className="hidden"
          style={{display: 'none'}}
          id="e-dp-uploader"
          accept="image/*"
          uploadStatus={this.uploadStatus.bind(this)}
          uploadSucess={this.uploadSucess.bind(this)}
        />

      </div>
    );
  }
}

export default EditModal;
